import React, { useEffect } from 'react';

import { useFonts } from '@folklore/fonts';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import * as AppPropTypes from '../../lib/PropTypes';

import { useRootDomain, useLoading } from '../../contexts/SiteContext';
import Header from '../headers/Header';
import Modal from '../modals/Modal';

import styles from '../../../styles/layouts/employee.module.scss';

const propTypes = {
    site: AppPropTypes.site,
    page: AppPropTypes.page,
    pageLoading: PropTypes.bool,
    fonts: PropTypes.shape({
        google: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
        custom: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
    }),
    children: PropTypes.node,
};

const defaultProps = {
    site: null,
    page: null,
    pageLoading: false,
    fonts: {
        custom: {
            families: ['Agrandir', 'GarageGothic-Bold'],
        },
    },
    children: null,
};

const EmployeeLayout = ({ site, page, fonts, pageLoading, children }) => {
    const { loaded: fontsloaded = false } = useFonts(fonts);
    const { theme } = page || {};
    const { withoutMenu = false } = site || {};
    const { colors, elementsColor } = theme || {};
    const { loading } = useLoading();
    const rootDomain = useRootDomain();

    useEffect(() => {
        const { primary = null, secondary = null } = colors || {};
        if (primary !== null) {
            document.documentElement.style.setProperty('--gradientStop1', primary);
        }
        if (secondary !== null) {
            document.documentElement.style.setProperty('--gradientStop2', secondary);
        }
    }, [colors]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.fontsLoading]: !fontsloaded,
                },
            ])}
            style={{
                color: elementsColor,
            }}
        >
            <Header
                className={styles.header}
                inverted={elementsColor === 'black'}
                loading={pageLoading || loading}
                rootDomain={rootDomain}
                withoutMenu={withoutMenu}
            />
            <main
                className={classNames([
                    styles.content,
                    {
                        [styles.pageLoading]: loading,
                    },
                ])}
            >
                {children}
            </main>
            <Modal className={styles.modal} />
        </div>
    );
};

EmployeeLayout.propTypes = propTypes;
EmployeeLayout.defaultProps = defaultProps;

export default EmployeeLayout;
